import { React } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

import './Contact.scss'

import { useDocumentTitle, useDocumentConfig } from 'hooks/useDocument'

import Hero from 'modules/Hero'
import ServiceIcon from 'components/ServiceIcon'
import Picto from 'components/Picto'
import Icon from 'components/Icon'

const Contact = () => {
	useDocumentTitle(`Nous contacter`)
	useDocumentConfig(`blue`, false)

	return (
		<motion.main
			className='contact'
			initial={{ opacity: 0, transition: { duration: 0.3 } }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0, transition: { duration: 0.3 } }}
		>
			<Hero
				scene={5}
				scrollTo="Nous avons hâte d'échanger avec vous"
			>
				Parlons-en&nbsp;!
			</Hero>
			<section className='columns valign-center'>
				<div className='column-half align-left align-center mobile-second'>
					<ServiceIcon
						version="hidden"
						size="huge"
					/>
				</div>
				<div className='column-half align-left mobile-first mobile-margin-bottom'>
					<h1>Parlons-en&nbsp;!</h1>
					<p>
						Chez BIG et Nouf, on s’engage à répondre rapidement à vos demandes.<br />
						Discutons de votre projet et établissons ensemble un devis personnalisé selon vos besoins et exigences.
					</p>
					<p>
						C'est parti&nbsp;! Nous sommes convaincus que notre collaboration sera un succès et nous sommes impatients de vous accompagner dans la réalisation de vos projets&nbsp;!
					</p>
				</div>
			</section>

			<section className='contact-listing columns valign-center'>
				<div className='column-full align-left'>
					<h1>
						Vous avez des idées&nbsp;?<br />
						Nous avons les compétences.
					</h1>
				</div>
				<div className='column-half align-left'>
					<ul className='no-prefix'>
						<li>
							<Icon
								version='comment'
								size='big'
							/>
							<div>
								<h5>Ecrivez-nous</h5>
								<p>
									<Link
										className='link__underline'
										to='mailto:mdournel@bigetnouf.fr'
									>
										mdournel@bigetnouf.fr
									</Link>
									<br /><br />
									<Link
										className='link__underline'
										to='mailto:fbeaumont@bigetnouf.fr'
									>
										fbeaumont@bigetnouf.fr
									</Link>
								</p>
							</div>
						</li>
						<li>
							<Icon
								version='mobile'
								size='big'
							/>
							<div>
								<h5>Appelez-nous</h5>
								<p className='light'>Quand vous voulez, du lundi au vendredi de 9h à 18h.</p>
								<p>
									<Link
										className='link__underline'
										to='tel:+33695179184'
									>
										06&nbsp;95&nbsp;17&nbsp;91&nbsp;84
									</Link> (Marion)
									<br /><br />
									<Link
										className='link__underline'
										to='tel:+33632761395'
									>
										06&nbsp;32&nbsp;76&nbsp;13&nbsp;95
									</Link> (François)
								</p>
							</div>
						</li>
						{/* <li>
							<Icon
								version='link'
								size='big'
							/>
							<div>
								<h5>Et suivez-nous&nbsp;!</h5>
								<p>
									<Link
										to='https://www.linkedin.com/company/big-et-nouf/'
										className='social link__icon'
										title='LinkedIn'
									>
										<Icon
											version='linkedin'
											size='smaller'
										/>
									</Link>
									<Link
										to='https://www.instagram.com/big.et.nouf/'
										className='social link__icon'
										title='Instagram'
									>
										<Icon
											version='instagram'
											size='smaller'
										/>
									</Link>
									<Link
										to='https://www.facebook.com/big.et.nouf/'
										className='social link__icon'
										title='Facebook'
									>
										<Icon
											version='facebook'
											size='smaller'
										/>
									</Link>
								</p>
							</div>
						</li> */}
					</ul>
				</div>
				<div className='column-half align-right mobile-margin-top mobile-align-center'>
					<Picto
						version='contact'
						size='huge'
					/>
				</div>
			</section>
		</motion.main>
	)
}

export default Contact
